export const GET_FOOD_LOG_RANGE = 'foodLog/GET_FOOD_LOG_RANGE';
export const GET_FOOD_LOG_RANGE_SUCCESS = 'foodLog/GET_FOOD_LOG_RANGE_SUCCESS';
export const GET_FOOD_LOG_RANGE_ERROR = 'foodLog/GET_FOOD_LOG_RANGE_ERROR';
